"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("../../styles/components"));

var _ListContext = _interopRequireDefault(require("./ListContext"));

var _ListNodeLabel = _interopRequireDefault(require("./ListNodeLabel"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ListNode = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ListNode, _React$PureComponent);

  function ListNode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      collapsed: true
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function () {
      var collapsed = _this.state.collapsed;

      _this.setState({
        collapsed: !collapsed
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var value = _this.props.value;
      var _this$context = _this.context,
          onChange = _this$context.onChange,
          selections = _this$context.selections;
      var selected = selections.some(function (selection) {
        return (0, _lodash.isEqual)(selection, value);
      });

      if (selected) {
        onChange(selections.filter(function (selection) {
          return !(0, _lodash.isEqual)(selection, value);
        }), [value]);
      } else {
        onChange([value], selections.filter(function (selection) {
          return !(0, _lodash.isEqual)(selection, value);
        }));
      }
    });

    return _this;
  }

  var _proto = ListNode.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        id = _this$props.id,
        title = _this$props.title,
        badge = _this$props.badge,
        value = _this$props.value,
        icon = _this$props.icon;
    var collapsed = this.state.collapsed;
    var selections = this.context.selections;
    var selected = selections.some(function (selection) {
      return (0, _lodash.isEqual)(selection, value);
    });

    if (!_react["default"].Children.count(children)) {
      return /*#__PURE__*/_react["default"].createElement(_ListNodeLabel["default"], {
        title: title,
        badge: badge,
        icon: icon,
        selected: selected,
        onClick: this.handleClick
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_components["default"].ListGroup, {
      selected: selected
    }, /*#__PURE__*/_react["default"].createElement(_components["default"].ListGroupHeader, null, /*#__PURE__*/_react["default"].createElement(_ListNodeLabel["default"], {
      title: title,
      badge: badge,
      icon: icon,
      selected: selected,
      collapsed: collapsed,
      onToggleCollapse: this.toggleCollapse,
      onClick: this.handleClick
    })), /*#__PURE__*/_react["default"].createElement(_components["default"].ListGroupBody, {
      collapsed: collapsed
    }, children));
  };

  return ListNode;
}(_react["default"].PureComponent);

_defineProperty(ListNode, "contextType", _ListContext["default"]);

var _default = ListNode;
exports["default"] = _default;